module.exports = __webpack_public_path__ + "img/flag-icon-idn.dbda7d0f.svg";